const azureSearchUri = window.SIMPL.azureSearchUri;
const azureSearchApiKey = window.SIMPL.azureSearchApiKey;

export default function searchRequest(queryUrl) {
    let url = azureSearchUri + queryUrl;
    let options = {
        headers:
        {
            'api-key': azureSearchApiKey
        }
    };
    return fetch(url, options);
}
